import {
  CurrencyInput,
  CurrencyInputProps,
} from 'app/components/ui/CurrencyInput'
import { addErrorDataAttribute } from 'app/components/ui/ErrorFormScrollHandler'
import { FormFeedback } from 'app/components/ui/FormFeedback'
import { Label } from 'app/components/ui/Label'
import React from 'react'
import { Controller, get, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

type Props = {
  name: string
  label?: string
  labelColor?: string
  errorLabelColor?: string
  labelRequired?: boolean
  onChange?: () => void
} & Omit<CurrencyInputProps, 'value' | 'onChange'>

export const SmartCurrencyInput = ({
  name,
  id,
  label,
  labelColor,
  errorLabelColor,
  labelRequired,
  className,
  onChange,
  ...rest
}: Props): JSX.Element => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  const error = get(errors, name)

  return (
    <div className={className}>
      {label && (
        <Label htmlFor={id ?? name} color={labelColor} disabled={rest.disabled}>
          {label} {labelRequired ? <RequiredSpan> * </RequiredSpan> : null}
        </Label>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          const { onChange: onChangeRegister, ...fieldProps } = field

          return (
            <CurrencyInput
              id={id ?? name}
              onChange={(e) => {
                // Calls react hook form onChange, needed for form to work
                onChangeRegister(e)

                // Calls custom onChange if present
                if (onChange) onChange()
              }}
              {...fieldProps}
              {...rest}
              invalid={!!error}
              {...addErrorDataAttribute(!!error)}
            />
          )
        }}
      />

      {error ? (
        <FormFeedback customColor={errorLabelColor} variant='error'>
          {error.message}
        </FormFeedback>
      ) : null}
    </div>
  )
}

const RequiredSpan = styled.span`
  color: ${({ theme }) => theme.color.secondari.arancioneScuro};
`
